export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-cyrillic-400-normal.woff?e2841352dd9512ff455bdb63b5b1e423";